export default ({ request }) => ({
  sysOaConfigureListApi(data = {}) {
    return request({
      url: '/sys/oa/configure/list',
      method: 'post',
      data,
    })
  },
  sysOaConfigureDetailApi(data = {}) {
    return request({
      url: '/sys/oa/configure/detail',
      method: 'post',
      data,
    })
  },
  sysOaConfigureSaveApi(data = {}) {
    return request({
      url: '/sys/oa/configure/save',
      method: 'post',
      data,
    })
  },
  sysOaConfigureEditApi(data = {}) {
    return request({
      url: '/sys/oa/configure/edit',
      method: 'post',
      data,
    })
  },
  sysOaConfigureDelApi(data = {}) {
    return request({
      url: '/sys/oa/configure/del',
      method: 'post',
      data,
    })
  },
})
